import DateRangePicker from '@wojtekmaj/react-daterange-picker' // theme css file
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

const AppDateRange = ({ ...props }) => {
  return <DateRangePicker {...props} />
}

export default AppDateRange